import { useAppDispatch } from "@/store";
import ProductCardSkeleton from "@/components/product-card/product-card-skeleton";
import Accordion from "react-bootstrap/Accordion";
import {
  fetchCategoryFiltersByIdWizzy,
  fetchLoadMoreCategoryProductsByIdWizzy,
  fetchMoreSearchProductsByWizzy,
  fetchSearchProductByunbxd,
  fetchMoreSearchProductsByUnbxd,
  selectCategory,
  fetchCategoryFiltersByUnbxd,
  fetchMoreCategoryProductsByUnbxd,
} from "@/store/slices/category";
import styles from "@/styles/product_list.module.scss";
import { useRouter } from "next/router";
import React, {
  Fragment,
  useEffect,
  useState,
  useRef,
  useCallback,
} from "react";
import Spinner from "react-bootstrap/Spinner";
import { useSelector } from "react-redux";
import CatgeoryBreadcrumb from "../breadcrumb/breadcrumb";
import Image from "next/image";
import { combineCategoryFilters } from "@/utils/combineCategoryFilters";
import ProductCardWizzy from "@/components/product-card-wizzy/product-card";
import PaginationCounterWizzy from "../pagination-counter/pagination-counter";
import { S3ImageLoader } from "@/image-loaders/s3-image-loader";
import ProductCardUnbxd from "@/components/product-card-unbxd/product-card";
import PaginationCounterUnbxd from "../pagination-counter/pagination-counter";
import { trackViewItemList, GA4_ITEM_BRAND } from "@/lib/ga4";

const CategoryProductsListUnbxd = () => {
  const categoryState = useSelector(selectCategory);
  console.log("category", categoryState);
  const dispatch = useAppDispatch();
  const router = useRouter();

  const isTryOnLanding =
    router.route === "/jewellery" &&
    router.query?.try_it_online === "yes" &&
    !router.query?.q;
  console.log("istry", isTryOnLanding);

  const apiFilterQuery = () => {
    let filter: any = {
      // page: 1,
      productsCount: 20,
      currency: "",
      getAllVariants: "false",
      showOOSProductsInOrder: "false",
      attributeFacetValuesLimit: 20,
    };
    if (router.query?.fastDelivery) {
      filter["fast_delivery"] = ["true"];
    }
    if (router.query?.try_it_online) {
      filter["try_online"] = ["true"];
    }
    if (router.query?.metal?.length) {
      filter["purity"] =
        typeof router.query?.metal !== "string"
          ? router.query?.metal
          : [router.query?.metal];
    }
    if (router.query?.occasion?.length) {
      filter["occasions"] =
        typeof router.query?.occasion !== "string"
          ? router.query?.occasion
          : [router.query?.occasion];
    }
    if (router.query?.priceMin || router.query?.priceMax) {
      filter.sellingPrice = {
        lte: router.query?.priceMax || 99999999999,
        gte: router.query?.priceMin || 0,
      };
    }
    if (router.query?.sort?.length) {
      filter.sort =
        router.query?.sort == "price-asc"
          ? "sellingPrice asc"
          : "sellingPrice desc";
    } else {
      if (router.route == "/jewellery") {
        if (router.query?.try_it_online == "yes") {
          filter.sort = [
            { field: "priority:float", order: "asc" },
            { field: "sellingPrice", order: "asc" },
          ];
        } else {
          // filter.sort =
          //   router.query?.sort == "price-asc"
          //     ? "sellingPrice asc"
          //     : "sellingPrice desc";
        }
      } else {
        //   filter.sort =
        //     router.query?.sort == "price-asc"
        //       ? "sellingPrice asc"
        //       : "sellingPrice desc";
        // }
      }
      // filter.sort = "priority asc";
    }
    return filter;
  };

  const [isSearch, setIsSearch] = useState(false);
  const [isFetching, setIsFetching] = useState(false);

  const hasMore = !!(
    categoryState.products &&
    categoryState.products?.response?.products.length <
      categoryState.products?.response?.numberOfProducts
  );

  const loadMore = useCallback(async () => {
    if (isFetching || categoryState.productsLoading || !hasMore) return;
    setIsFetching(true);
    try {
      if (categoryState.products) {
        if (isSearch) {
          await dispatch(
            fetchMoreSearchProductsByUnbxd({
              query: {
                page:
                  categoryState.products?.response?.start !== 0
                    ? Number(
                        (categoryState.products?.response?.start + 20) / 20
                      ) + 1
                    : 2,
                search: router.query.q,
                ...apiFilterQuery(),
                q: router.query.q,
                searchedKey: categoryState.products.filters?.searchedKey,
              },
            })
          );
        } else if (categoryState.data && !isTryOnLanding) {
          await dispatch(
            fetchMoreCategoryProductsByUnbxd({
              query: {
                page:
                  categoryState.products?.response?.start !== 0
                    ? Number(
                        (categoryState.products?.response?.start + 20) / 20
                      ) + 1
                    : 2,
                ...apiFilterQuery(),
                categoryPath: categoryState.mapping.length
                  ? categoryState.mapping.map((item) => item.name).join(">") +
                    `>${categoryState.data?.name}`
                  : categoryState.data?.name,
                categories: String(categoryState.data?.id),
                searchedKey: categoryState.products.filters?.searchedKey,
              },
            })
          );
        } else if (isTryOnLanding) {
          await dispatch(
            fetchMoreCategoryProductsByUnbxd({
              query: {
                page:
                  categoryState.products?.response?.start !== 0
                    ? Number(
                        (categoryState.products?.response?.start + 20) / 20
                      ) + 1
                    : 2,
                try_online: true,
                ...apiFilterQuery(),
              },
            })
          );
        }
      }
    } catch (error) {
      console.error("Error loading more products:", error);
    } finally {
      setIsFetching(false);
    }
  }, [
    isFetching,
    categoryState.productsLoading,
    hasMore,
    categoryState.products,
    categoryState.data,
    categoryState.mapping,
    isSearch,
    isTryOnLanding,
    router.query,
    dispatch,
  ]);

  const observerRef = useRef<IntersectionObserver | null>(null);
  const bottomRef = useCallback(
    (node: HTMLDivElement | null) => {
      if (observerRef.current) observerRef.current.disconnect();
      if (!node) return;

      observerRef.current = new IntersectionObserver(
        (entries) => {
          if (
            entries[0].isIntersecting &&
            hasMore &&
            !isFetching &&
            !categoryState.productsLoading
          ) {
            loadMore();
          }
        },
        {
          rootMargin: "200px",
        }
      );
      observerRef.current.observe(node);
    },
    [loadMore, hasMore, isFetching, categoryState.productsLoading]
  );

  useEffect(() => {
    return () => {
      if (observerRef.current) observerRef.current.disconnect();
    };
  }, []);

  useEffect(() => {
    if (categoryState.data) {
      if (
        !router.query.sort &&
        ["bangle-utsav-collection-2023"].includes(categoryState.data.slug)
      ) {
        router.replace(
          {
            pathname: "/jewellery/category/[category]",
            query: {
              category: categoryState.data?.slug,
              ...combineCategoryFilters({
                ...router.query,
                sort: "price-asc",
              }),
            },
          },
          undefined,
          { shallow: true }
        );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [categoryState.data, dispatch]);

  useEffect(() => {
    console.log("....");
    if (!isTryOnLanding) {
      if (router.route == "/jewellery") {
        setIsSearch(true);
        if (
          router.query?.fastDelivery ||
          router.query?.sort ||
          router.query?.occasion ||
          router.query?.metal ||
          router.query?.priceMax ||
          router.query?.priceMin
        ) {
          console.log("search with filter");

          dispatch(
            fetchSearchProductByunbxd({
              query: {
                ...apiFilterQuery(),
                search: router.query.q,
                q: router.query.q,

                searchedKey: categoryState.products?.filters?.searchedKey,
              },
              // query: {
              //   search: router.query.q,
              //   tryItOnline: router.query.try_it_online,
              //   filters: {
              //     ...apiFilterQuery(),
              //     search: router.query.q,
              //     q: router.query.q,
              //     searchedKey: categoryState.products?.filters?.searchedKey,
              //     includeCategoriesFacetForPage: "true",
              //     facets: [
              //       { key: "purity" },
              //       { key: "occasions" },
              //       { key: "categories" },
              //     ],
              //   },
              // },
            })
          );
        } else {
          console.log("search");
          dispatch(
            fetchSearchProductByunbxd({
              query: {
                ...apiFilterQuery(),
                search: router.query.q,
                q: router.query.q,

                searchedKey: categoryState.products?.filters?.searchedKey,
              },
            })
          );
        }
      } else {
        console.log(
          "category",
          categoryState.data,
          !categoryState.mappingLoading
        );

        if (categoryState.data && !categoryState.mappingLoading) {
          if (
            !router.query.sort &&
            ["bangle-utsav-collection-2023"].includes(categoryState.data.slug)
          ) {
            router.replace(
              {
                pathname: "/jewellery/category/[category]",
                query: {
                  category: categoryState.data?.slug,
                  ...combineCategoryFilters({
                    ...router.query,
                    sort: "price-asc",
                  }),
                },
              },
              undefined,
              { shallow: true }
            );
          } else {
            console.log(
              "category slug",
              categoryState.data,
              categoryState.mapping
            );

            dispatch(
              fetchCategoryFiltersByUnbxd({
                query: {
                  tryItOnline: router.query.try_it_online,
                  ...apiFilterQuery(),
                  categoryPath: categoryState.mapping.length
                    ? categoryState.mapping.map((item) => item.name).join(">") +
                      `>${categoryState.data?.name}`
                    : categoryState.data?.name,
                  categories: String(categoryState.data?.id),
                  // includeCategoriesFacetForPage: "true",
                  // facets: [
                  //   { key: "purity" },
                  //   { key: "occasions" },
                  //   { key: "categories" },
                  // ],
                },
              })
            );
          }
        }
      }
    } else {
      dispatch(
        fetchCategoryFiltersByUnbxd({
          query: {
            try_online: true,
            ...apiFilterQuery(),
          },
        })
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    router.query?.fastDelivery,
    router.query?.try_it_online,
    router.query?.sort,
    router.query?.occasion,
    router.query?.metal,
    router.query?.priceMax,
    router.query?.priceMin,
    router.query.q,
    router.query.category,
    categoryState.mapping,
    !isTryOnLanding,
  ]);

  // Track GA4 view_item_list event when products load
  useEffect(() => {
    if (
      categoryState.products?.response?.products &&
      categoryState.products.response.products.length > 0 &&
      !categoryState.productsLoading
    ) {
      console.log(categoryState.data);
      const items = categoryState.products.response.products.map(
        (product: any, index: number) => ({
          item_id: product.uniqueId || String(product.productId),
          item_name: product.title,
          item_brand: GA4_ITEM_BRAND,
          item_category: product.categoryPath1
            ? product.categoryPath1.split(">").pop()?.trim()
            : undefined,
          price: product.sellingPrice || product.price,
          quantity: 1,
          index: index,
        })
      );

      if (isSearch) {
        // Search results page
        trackViewItemList({
          item_list_id: "search_results",
          item_list_name: `Search: ${router.query.q || ""}`,
          items: items,
        });
      } else if (categoryState.data) {
        // Category page
        trackViewItemList({
          item_list_id: `category_${categoryState.data.id}`,
          item_list_name: categoryState.data.name || categoryState.data.title,
          items: items,
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    categoryState.products?.response?.products,
    categoryState.productsLoading,
    isSearch,
    categoryState.data,
  ]);

  return (
    <div className={`${styles.container} ${"container"}`}>
      <div className="row g-3">
        {categoryState.productsLoading &&
          new Array(8).fill(1).map((_, k) => (
            <div className="col-md-3" key={k}>
              <ProductCardSkeleton />
            </div>
          ))}
        {/* <p>{JSON.stringify(categoryState.products?.response.prducts)}</p> */}
        {categoryState.products?.response?.products &&
          categoryState.products.response.products.map(
            (product: any, index: any) => (
              // <Fragment key={product.sku}>
              //   {index == 10 && categoryState.data?.inner_banner_1 && (
              //     <div className="col-md-12 col-lg-6 col-12 d-none d-md-block">
              //       <div
              //         className={`${styles.position_relative} ${styles.w_100} ${styles.custom_height_list} ${styles.h_100}`}
              //       >
              //         <Image
              //           src={categoryState.data?.inner_banner_1}
              //           layout="fill"
              //           alt="Inner banner 1"
              //           priority
              //           width={696}
              //           height={589}
              //           sizes="(max-width: 479px) 84px, (max-width: 640px) 129px, (max-width: 991px) 318px, (max-width: 1199px) 318px, (max-width: 1399px) 696px"
              //           loader={S3ImageLoader}
              //         />
              //       </div>
              //     </div>
              //   )}
              //   {/* mobile banner 1 */}
              //   {index == 10 && categoryState.data?.mob_inner_banner_1 && (
              //     <div className="col-md-12 col-lg-6 col-12 d-block d-md-none">
              //       <a className={styles.border_sen_radius}
              //       >
              //         <Image
              //           src={categoryState.data?.mob_inner_banner_1}
              //           layout="responsive"
              //           alt="Mobile Inner banner 1"
              //           priority
              //           width={696}
              //           height={589}
              //            objectFit="cover"
              //            sizes="100vw"
              //           loader={S3ImageLoader}
              //         />
              //       </a>
              //     </div>
              //   )}
              //   {index == 18 && categoryState.data?.inner_banner_2 && (
              //     <div className="col-md-12 col-lg-12 col-12 d-none d-md-block">
              //        <a className={styles.border_sen_radius}>
              //                             <Image
              //                               src={categoryState.data?.inner_banner_2}
              //                               layout="responsive"
              //                               width={1920}
              //                               height={400}
              //                               objectFit="cover"
              //                               alt="Inner banner 2"
              //                               priority
              //                               sizes="100vw"
              //                               loader={S3ImageLoader}
              //                             />
              //                           </a>
              //     </div>
              //   )}
              //   {/* mobile banner 2 */}
              //   {index == 18 && categoryState.data?.mob_inner_banner_2 && (
              //     <div className="col-md-12 col-lg-6 col-12 d-block d-md-none">
              //       <a className={styles.border_sen_radius}
              //       >
              //         <Image
              //           src={categoryState.data?.mob_inner_banner_2}
              //           layout="responsive"
              //           alt="Mobile Inner banner 2"
              //           priority
              //           width={696}
              //           height={589}
              //            objectFit="cover"
              //            sizes="100vw"
              //           loader={S3ImageLoader}
              //         />
              //       </a>
              //     </div>
              //   )}
              //   {index == 30 && categoryState.data?.inner_banner_3 && (
              //     <div className="col-md-12 col-lg-6 col-12 d-none d-md-block">
              //       <div
              //         className={`${styles.position_relative} ${styles.w_100} ${styles.custom_height_list} ${styles.h_100}`}
              //       >
              //         <Image
              //           src={categoryState.data?.inner_banner_3}
              //           layout="fill"
              //           alt="Inner banner 3"
              //           priority
              //           width={696}
              //           height={589}
              //           sizes="(max-width: 479px) 84px, (max-width: 640px) 129px, (max-width: 991px) 318px, (max-width: 1199px) 318px, (max-width: 1399px) 696px"
              //           loader={S3ImageLoader}
              //         />
              //       </div>
              //     </div>
              //   )}
              //   {/* mobile banner 3 */}
              //   {index == 30 && categoryState.data?.mob_inner_banner_3 && (
              //     <div className="col-md-12 col-lg-6 col-12 d-block d-md-none">
              //       <a className={styles.border_sen_radius}
              //       >
              //         <Image
              //           src={categoryState.data?.mob_inner_banner_3}
              //           layout="responsive"
              //           alt="Mobile Inner banner 3"
              //           priority
              //           width={696}
              //           height={589}
              //            objectFit="cover"
              //            sizes="100vw"
              //           loader={S3ImageLoader}
              //         />
              //       </a>
              //     </div>
              //   )}
              //   {index == 40 && categoryState.data?.inner_banner_4 && (
              //     <div className="col-md-12 col-lg-12 col-12 ">
              //                         <a className={`${styles.border_sen_radius} ${"d-none d-md-block"}`}
              //                         >
              //                           <Image
              //                             src={categoryState.data?.inner_banner_4}
              //                            layout="responsive"
              //                             width={1920}
              //                             height={400}
              //                             objectFit="cover"
              //                             alt="Inner banner 4"
              //                             priority
              //                             sizes="100vw"
              //                             loader={S3ImageLoader}
              //                           />
              //                         </a>
              //                       </div>
              //   )}
              //   {/* mobile banner 4 */}
              //   {index == 38 && categoryState.data?.mob_inner_banner_4 && (
              //     <div className="col-md-12 col-lg-6 col-12 d-block d-md-none">
              //       <a className={styles.border_sen_radius}
              //       >
              //         <Image
              //           src={categoryState.data?.mob_inner_banner_4}
              //           layout="responsive"
              //           alt="Mobile Inner banner 4"
              //           priority
              //           width={696}
              //           height={589}
              //           objectFit="cover"
              //            sizes="100vw"
              //           loader={S3ImageLoader}
              //         />
              //       </a>
              //     </div>
              //   )}
              //   <div className="col-md-6 col-lg-3 col-6">
              //     <ProductCardUnbxd product={product} />
              //   </div>
              // </Fragment>
              <Fragment key={product.sku}>
                {index == 10 && categoryState.data?.inner_banner_1 && (
                  <div className="col-md-12 col-lg-6 col-12 d-none d-md-block">
                    <div
                      className={`${styles.position_relative} ${styles.w_100} ${styles.custom_height_list} ${styles.h_100}`}
                    >
                      <Image
                        src={categoryState.data?.inner_banner_1}
                        layout="fill"
                        alt="Inner banner 1"
                        priority
                        width={696}
                        height={589}
                        sizes="(max-width: 479px) 84px, (max-width: 640px) 129px, (max-width: 991px) 318px, (max-width: 1199px) 318px, (max-width: 1399px) 696px"
                        loader={S3ImageLoader}
                      />
                    </div>
                  </div>
                )}
                {index == 10 && categoryState.data?.mob_inner_banner_1 && (
                  <div className="col-md-12 col-lg-6 col-12 d-block d-md-none">
                    <div className={styles.border_sen_radius}>
                      <Image
                        src={categoryState.data?.mob_inner_banner_1}
                        layout="responsive"
                        alt="Mobile Inner banner 1"
                        priority
                        width={696}
                        height={589}
                        objectFit="cover"
                        sizes="100vw"
                        loader={S3ImageLoader}
                      />
                    </div>
                  </div>
                )}
                {index == 14 && categoryState.data?.inner_banner_2 && (
                  <div className="col-md-12 col-lg-6 col-12 d-none d-md-block">
                    <div
                      className={`${styles.position_relative} ${styles.w_100} ${styles.custom_height_list} ${styles.h_100}`}
                    >
                      <Image
                        src={categoryState.data?.inner_banner_2}
                        layout="fill"
                        alt="Inner banner 2"
                        priority
                        width={696}
                        height={589}
                        sizes="(max-width: 479px) 84px, (max-width: 640px) 129px, (max-width: 991px) 318px, (max-width: 1199px) 318px, (max-width: 1399px) 696px"
                        loader={S3ImageLoader}
                      />
                    </div>
                  </div>
                )}
                {index == 14 && categoryState.data?.mob_inner_banner_2 && (
                  <div className="col-md-12 col-lg-6 col-12 d-block d-md-none">
                    <div className={styles.border_sen_radius}>
                      <Image
                        src={categoryState.data?.mob_inner_banner_2}
                        layout="responsive"
                        alt="Mobile Inner banner 2"
                        priority
                        width={696}
                        height={589}
                        objectFit="cover"
                        sizes="100vw"
                        loader={S3ImageLoader}
                      />
                    </div>
                  </div>
                )}
                {index == 20 && categoryState.data?.landscape_inner_banner && (
                  <div className="col-md-12 col-lg-12 col-12 d-none d-md-block">
                    <div className={styles.border_sen_radius}>
                      <Image
                        src={categoryState.data?.landscape_inner_banner}
                        layout="responsive"
                        alt="Landscape Inner banner"
                        priority
                        width={1920}
                        height={400}
                        objectFit="cover"
                        sizes="100vw"
                        loader={S3ImageLoader}
                      />
                    </div>
                  </div>
                )}
                {index == 30 && categoryState.data?.inner_banner_3 && (
                  <div className="col-md-12 col-lg-6 col-12 d-none d-md-block">
                    <div
                      className={`${styles.position_relative} ${styles.w_100} ${styles.custom_height_list} ${styles.h_100}`}
                    >
                      <Image
                        src={categoryState.data?.inner_banner_3}
                        layout="fill"
                        alt="Inner banner 3"
                        priority
                        width={696}
                        height={589}
                        sizes="(max-width: 479px) 84px, (max-width: 640px) 129px, (max-width: 991px) 318px, (max-width: 1199px) 318px, (max-width: 1399px) 696px"
                        loader={S3ImageLoader}
                      />
                    </div>
                  </div>
                )}
                {index == 30 && categoryState.data?.mob_inner_banner_3 && (
                  <div className="col-md-12 col-lg-6 col-12 d-block d-md-none">
                    <div className={styles.border_sen_radius}>
                      <Image
                        src={categoryState.data?.mob_inner_banner_3}
                        layout="responsive"
                        alt="Mobile Inner banner 3"
                        priority
                        width={696}
                        height={589}
                        objectFit="cover"
                        sizes="100vw"
                        loader={S3ImageLoader}
                      />
                    </div>
                  </div>
                )}
                {index == 38 && categoryState.data?.inner_banner_4 && (
                  <div className="col-md-12 col-lg-6 col-12 d-none d-md-block">
                    <div
                      className={`${styles.position_relative} ${styles.w_100} ${styles.custom_height_list} ${styles.h_100}`}
                    >
                      <Image
                        src={categoryState.data?.inner_banner_4}
                        layout="fill"
                        alt="Inner banner 4"
                        priority
                        width={696}
                        height={589}
                        sizes="(max-width: 479px) 84px, (max-width: 640px) 129px, (max-width: 991px) 318px, (max-width: 1199px) 318px, (max-width: 1399px) 696px"
                        loader={S3ImageLoader}
                      />
                    </div>
                  </div>
                )}
                {index == 38 && categoryState.data?.mob_inner_banner_4 && (
                  <div className="col-md-12 col-lg-6 col-12 d-block d-md-none">
                    <div className={styles.border_sen_radius}>
                      <Image
                        src={categoryState.data?.mob_inner_banner_4}
                        layout="responsive"
                        alt="Mobile Inner banner 4"
                        priority
                        width={696}
                        height={589}
                        objectFit="cover"
                        sizes="100vw"
                        loader={S3ImageLoader}
                      />
                    </div>
                  </div>
                )}
                <div className="col-md-6 col-lg-3 col-6">
                  <ProductCardUnbxd product={product} />
                </div>
              </Fragment>
            )
          )}
        {!categoryState.products?.response?.products?.length &&
          !categoryState.productsLoading && (
            <h1 className="text-center">No records found</h1>
          )}
      </div>
      <div className={styles.show_contant}>
        <p className="text-center">
          <PaginationCounterUnbxd />
        </p>
        <div className="row mb-4 mt-4 ">
          <div className="col-md-4">
            <div className={styles.breadcrumb_main}>
              {!isSearch && <CatgeoryBreadcrumb />}
            </div>
          </div>
          <div className="col-md-4 d-flex flex-column align-items-center justify-content-center">
            {isFetching && (
              <div className="d-flex align-items-center justify-content-center py-3">
                <Spinner
                  animation="border"
                  role="status"
                  style={{ color: "rgb(143, 0, 6)" }}
                >
                  <span className="visually-hidden">Loading...</span>
                </Spinner>
              </div>
            )}
            <div ref={bottomRef} style={{ height: "10px", width: "100%" }} />
          </div>
          <div className="col-md-4 text-md-end text-center mt-3 mt-md-0">
            {/* <a href="#" className="text-md-end">
              BACK TO TOP
            </a> */}
          </div>
        </div>
        {!!categoryState.data?.content && (
          <>
          <div className={styles.product_list_seo_text_size}>
            <div className={styles.product_list_contant}>
              {!!categoryState.data.content.title && (
                <div className={styles.product_heading_text}>
                  {categoryState.data.content.title}
                </div>
              )}
              {!!categoryState.data.content.description && (
                <div
                  className={styles.product_bottomg_text}
                  dangerouslySetInnerHTML={{
                    __html: categoryState.data.content.description
                      .replace(/nofollow/g, "")
                      .replace(/noopener/g, "")
                      .replace(/noreferrer/g, ""),
                  }}
                ></div>
              )}
            </div>
            {!!categoryState.data.content.items?.length && (
              <div className={styles.accordion_container}>
                <Accordion defaultActiveKey="0">
                  {categoryState.data.content.items.map((item, index) => (
                    <Accordion.Item eventKey={`${index}`} key={index}>
                      <Accordion.Header as="div">{item.title}</Accordion.Header>
                      <Accordion.Body
                        dangerouslySetInnerHTML={{
                          __html: item.description
                            .replace(/nofollow/g, "")
                            .replace(/noopener/g, "")
                            .replace(/noreferrer/g, ""),
                        }}
                      ></Accordion.Body>
                    </Accordion.Item>
                  ))}
                </Accordion>
              </div>
            )}
          </div>
          </>
        )}
      </div>
    </div>
  );
};

export default CategoryProductsListUnbxd;
